// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToggle__DrawerToggle__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/SideDrawer/DrawerToggle/DrawerToggle.scss
// module id = 121
// module chunks = 0